import { Check } from "@components/icons"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import animation, { cubicBezier } from "@constants/animation"
import colors from "@constants/colors"
import { body16MainStyles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

export const ItemContainer = styled.div`
  display: flex;
  height: auto;
  padding: 8px 24px;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.offWhite};
  border: none;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    transition: background-color ${animation.quick} ${cubicBezier};
    background-color: ${colors.dividerLineGray};
    cursor: pointer;
  }
`

const CheckWrapper = styled.div<{
  toggled?: boolean
}>`
  position: absolute;
  left: 18px;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  transition: opacity ${animation.quick} ${cubicBezier};
  opacity: ${({ toggled }) => (toggled ? "1" : "0")};

  ${({ toggled }) =>
    toggled &&
    `
    transition: opacity ${animation.medium} ${cubicBezier};
  `}
`

const IconWrapper = styled.div`
  ${ImageHelperContainer} {
    width: 16px;
    height: 12px;
    line-height: 20px;
    vertical-align: center;

    img {
      object-fit: contain;
    }
  }
`

const Spacer = styled.div`
  width: 8px;
`

const LabelWrapper = styled.div<{
  toggled?: boolean
}>`
  display: flex;
  align-items: center;
  transform: translateX(0);
  transition: transform ${animation.medium} ${cubicBezier};

  ${({ toggled }) =>
    toggled &&
    `
      transform: translateX(26px);
      transition: transform ${animation.quick} ${cubicBezier};
  `}
`

const Label = styled.div<{ color?: string; toggled?: boolean }>`
  ${body16MainStyles}
  color: ${({ color }) => (color ? `#${color}` : colors.mediumDarkGray)};

  ${({ color, toggled }) => toggled && !color && `color: ${colors.black};`}
`

export interface MenuItemTogglableCompactProps {
  color?: string
  icon?: string
  label: string
  onClick?: () => void
  toggled?: boolean
}

const MenuItemTogglableCompact: React.FC<MenuItemTogglableCompactProps> = ({
  color,
  icon,
  label,
  onClick,
  toggled,
}) => (
  <ItemContainer
    onClick={() => {
      if (onClick) {
        onClick()
        window.scrollTo({ behavior: "smooth", top: 0 })
      }
    }}
  >
    <CheckWrapper toggled={toggled}>
      <Check />
    </CheckWrapper>
    <LabelWrapper toggled={toggled}>
      {icon && (
        <>
          <IconWrapper>
            <ImageHelper src={icon} />
          </IconWrapper>
          <Spacer />
        </>
      )}
      <Label color={color} toggled={toggled}>
        {label}
      </Label>
    </LabelWrapper>
  </ItemContainer>
)

export default MenuItemTogglableCompact
